__webpack_require__.p = "/seat-map/";